<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Produccion</h1>
                <div class="caption">
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-checkbox v-model="d.paneles" label="¿Sólo paneles?"></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
        <v-menu
                v-model="seriesShow"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                min-width="500"
        >
            <v-card raised>
                <v-card-text>
                    <highcharts style="width: 100%" :options="chartSeriesOptions"></highcharts>
                </v-card-text>
            </v-card>
        </v-menu>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect},
        data() {
            return {
                seriesTit: '',
                seriesShow: false,
                x: 0,
                y: 0,
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                    paneles:false
                },
                t: {},
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal',
                            point: {
                                events: {
                                    click: (e) => {
                                        console.log(e);
                                        this.x = e.x;
                                        this.y = e.y;
                                        this.seriesTit = e.point.name;
                                        this.traeSeries(e.point.ano, e.point.mes, e.point.name)
                                    }
                                }
                            }
                        },
                        column: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: false,
                                color: '#ffffff',
                                style: {
                                    textShadow: '0 0 3px black, 0 0 3px black'
                                },
                                format: '$ {y:,.2f}({point.percentage:.0f}%)'
                            }
                        }
                    },
                    title: {
                        text: 'Producción'
                    },
                    xAxis: {
                        type: 'category',
                        minRange: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color:  'gray',
                            },
                            format: '{total:,.2f}m2'
                        }
                    },
                    tooltip: {
                        pointFormat: '<span>{series.name}</span>: <b>{point.y:,.2f}m2 | {point.percentage:.0f}%</b><br/>',
                        shared: false
                    },
                    series: [{}]
                },
                chartSeriesOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'DESPACHOS POR SERIE'
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    }
                    ,
                    xAxis: {
                        type: 'category',
                        title:
                            {
                                text: 'Series'
                            }
                    }
                    ,
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        }
                        ,
                        stackLabels: {
                            enabled: true,
                            style:
                                {
                                    fontWeight: 'bold',
                                    color:
                                        'gray'
                                }
                            ,
                            format: '$ {total:,.2f}'
                        }
                        ,
                    }
                    ,
                    plotOptions: {
                        column: {
                            stacking: false,
                            grouping:
                                true,
                            dataLabels:
                                {
                                    enabled: true,
                                    format:
                                        '{y}'
                                }
                        }
                    }
                    ,
                    series: []
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/produccion', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data.datos;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            },
            traeSeries(ano, mes) {
                this.loading = true;
                this.$http.post('indicadores/produccion-series', {
                    ano: ano,
                    mes: mes,
                    empresa: this.d.empresa
                })
                    .then(r => {
                        this.chartSeriesOptions.series = r.data.datos;
                        this.chartSeriesOptions.title.text = 'Despachos por serie del mes ' + this.seriesTit;
                        this.$nextTick(() => {
                            this.seriesShow = true
                        })
                        this.loading = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/produccion.vue